import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';
import { useSoftphoneCallState } from '../../providers/softphone-call-state-provider';

export const IncomingCallBarPreview = ({
  setExpandedIncomingCallBar,
}: {
  setExpandedIncomingCallBar: (val: boolean) => void;
}) => {
  const incomingCalls = useSoftphoneCallState((ctx) => ctx.incomingCalls);
  const { t } = useTranslation('softphone');
  return (
    <section id='softphone-incoming-call-bar-preview' css={incomingCallBarPreviewStyles}>
      <Text size='medium' weight='bold' css={{ color: theme.colors.success30 }}>
        {t('+{{count}} New', { count: incomingCalls.length })}
      </Text>
      <NakedButton onClick={() => setExpandedIncomingCallBar(true)}>
        <Icon name='caret-right-small' color='white' />
      </NakedButton>
    </section>
  );
};

const incomingCallBarPreviewStyles = css`
  background-color: ${theme.colors.neutral90};
  border-radius: ${theme.borderRadius.medium};
  min-width: 111px;
  padding: ${theme.spacing(1, 2)};
  box-shadow: 0 0 8px 4px rgba(8, 135, 63, 0.5);
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
